export default function () {
  const widgetName = 'multiScheduleFeature';
  const widgetOpts = multiScheduleFeatureOpts;
  const $widget = $(`#${widgetName}`);

  const breakpoint = 800;
  const isDesktopScreen = $(window).width() >= breakpoint;

  $widget.append('<div class="multiFeatureContent"></div>');
  $('.tier-2-container .events-title').prependTo($widget);

  $widget.MultiScheduleFeature({
    scriptPath: widgetOpts.scriptPath,
    currentWidgetModuleItemID: widgetOpts.WidgetModuleDataItemID,
    detectIpad: IPADDETECTED,
    lazyLoadImages: true,
    maxItemsVisible: 5,
    isResponsive: false,
    allEventsLink: true,
    allEventsLinkText: 'view full calendar',
    link: isDesktopScreen ? [] : ['all'],
    attributeOrder: {
      1: 'image',
      2: 'title',
      3: 'date',
      4: 'description',
      5: 'buttons',
    },
    multiFeatureLoaded: function (data) {
      const eventsCount = data.length;

      if (!eventsCount) {
        $widget.remove();
        $('body').addClass('noEvents');
        return;
      }
      createCustomEventFeed(data);
      updateAllEventsButton();
    },
  });

  // ****************************************************************
  // Helpers
  function createCustomEventFeed(data) {
    $widget.find('.featureItem').each(function (i) {
      const event = data[i];
      const widgetImage = event.ImageURL || `${FULLCLIENTTHEMEPATH}images/no_image_available.jpg`;
      const dateLayout = generateDateLayout(event.Date);

      $(this)
        .empty()
        .append(
          buildEventInfoLayout(event.Name, widgetImage, event.URL, event.Purchaseable, dateLayout),
        );

      if (event.URL) {
        $(this).attr('href', event.URL);
      } else {
        $(this).removeAttr('href').addClass('void');
      }
    });
  }

  function buildEventInfoLayout(title, image, eventUrl, isPurchaseable, dateLayout) {
    let eventUrlValidation = isPurchaseable
      ? `<a href="${eventUrl}" class="button">Buy Now</a>`
      : '';
    return `
    <div class="img-container">

    ${eventUrl ? `<div class="overlay"></div>` : ''}
    ${
      eventUrl
        ? `<div class="buttons-container"><a href="${eventUrl}" class="button">More</a>${eventUrlValidation}</div>`
        : ''
    }

      <img src="${image}" alt="${title}" class="event-image">
    </div>
    <div class="event-info">
      ${dateLayout}
      <span class="arrow-separator"></span>
      <span class="event-name">${title}</span>
    </div>`;
  }

  function generateDateLayout(dateString) {
    const fixedDate = dateString.split('-');
    let [monthStart, dayStart, monthEnd, dayEnd] = ['', '', null, null];

    if (fixedDate.length === 1) {
      monthStart = formatDate(fixedDate[0], 0, 0).substring(0, 3);
      dayStart = formatDate(fixedDate[0], 0, 1);
    } else if (fixedDate.length === 2) {
      monthStart = formatDate(fixedDate[0], 0, 0);
      dayStart = formatDate(fixedDate[0], 0, 1);
      monthEnd = formatDate(fixedDate[1], 0, 0).substring(0, 3);
      dayEnd = formatDate(fixedDate[1], 0, 1);
    }

    return buildEventDateLayout(monthStart, dayStart, monthEnd, dayEnd);
  }

  function formatDate(date, partIndex, subPartIndex) {
    return date.trim().split(',')[partIndex].trim().split(' ')[subPartIndex].trim();
  }

  function buildEventDateLayout(
    eventStartMonth,
    eventStartDay,
    eventEndMonth = null,
    eventEndDay = null,
  ) {
    if (!eventEndMonth || !eventEndDay) {
      return `
      <div class="event-date">
        <span class="month">${eventStartMonth}</span>
        <span class="day">${eventStartDay}</span>
      </div>`;
    }
    return eventStartMonth === eventEndMonth
      ? `
      <div class="event-date double-date">
        <span class="month">${eventStartMonth}</span>
        <span class="day">${eventStartDay}<span class="separator">-</span>${eventEndDay}</span>
      </div>`
      : `
      <div class="event-date date-range">
        <div class="combo-date">
          <span class="month">${eventStartMonth}</span>
          <span class="day">${eventStartDay}</span>
        </div>
        <span class="separator-month">-</span>
        <div class="combo-date">
          <span class="month">${eventEndMonth}</span>
          <span class="day">${eventEndDay}</span>
        </div>
      </div>`;
  }

  function updateAllEventsButton() {
    const $button = $('.all-events-btn');
    $button
      .addClass('button')
      .appendTo('#multiScheduleFeature')
      .wrap('<div class="btn-container"></div>');
  }
}
